const initialState = {
  userId: null,
  role: "user",
};

function userReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_USER_ID":
      return {
        ...state,
        userId: action.payload,
      };
    case "SET_USER_ROLE":
      return {
        ...state,
        role: action.payload,
      };
    default:
      return state;
  }
}

export default userReducer;
